import { HeaderButton, HeaderButtonIdentifier } from '@/components/elements/HeaderButton/HeaderButton.types';
import { _s } from '@/locale';

const tBase = (key: string) => _s(`features.search-header.constants.${key}`);

const connectCompanyButton: HeaderButton = {
  icon: 'shop-alt',
  label: tBase('connectCompanyItem'),
  to: 'https://business.bokadirekt.se/',
  className: 'border-none',
  identifier: HeaderButtonIdentifier.ConnectCompany,
  breakpoint: 'min-[1280px]:inline-flex',
};

const loginButton: HeaderButton = {
  icon: 'user',
  label: tBase('loginItem'),
  identifier: HeaderButtonIdentifier.LogIn,
};

const profileButton: HeaderButton = {
  identifier: HeaderButtonIdentifier.Profile,
};

const favoritesButton: HeaderButton = {
  identifier: HeaderButtonIdentifier.Favorites,
  icon: 'heart',
  to: '/favoriter',
};

const myBookingsButton: HeaderButton = {
  identifier: HeaderButtonIdentifier.Bookings,
  icon: 'calendar-user',
  to: '/bokningar',
};

export const SEARCH_HEADER_BUTTON = {
  CONNECT_COMPANY: connectCompanyButton,
  PROFILE: profileButton,
  LOGIN: loginButton,
  FAVORITES: favoritesButton,
  MY_BOOKINGS: myBookingsButton,
} as const;
